module.exports = __webpack_public_path__ + "img/AXIS Logo for Dark Backgrounds - Cropped - Green.bf7f83b1.png";